export default "__VITE_ASSET__BRyY42Jh__"